<img data-test-id="header-logo" [src]="logoSrc" alt="Logo" [ngClass]="imgClasses" [attr.height]="imgHeight" />
